import React, { useState, useEffect } from "react";
import { styled } from "@linaria/react";
import { useHistory } from "react-router-dom";
import Link from "../../Components/Link";
import IconDonwload from "@assets/icon/download-purple.svg";
import IconArrow from "@assets/icon/chevron-right-purple.svg";
import Product1 from "@assets/icon/product-1.svg";
import Product2 from "@assets/icon/product-2.svg";
import Product3 from "@assets/icon/product-3.svg";
import Button from "@components/_Revamp/Button";
import { generatePlanOverView } from "@pages/ShieldStarter/Helpers/generatePlanOverView";
import { RadioButton, RadioButtonGroup } from "./../../Components/RadioButton";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import {
  updatePolicyName,
  updatePlanOverview,
} from "@redux/slices/SHIELD_STARTER/step2Slice";
import { ROUTE_PATH } from "@static/route-paths";
import {
  PRODUCT_SUMMARY_SHIELD_STARTER_HEALTH_PLUS,
  SHIELD_STARTER,
  SHIELD_STARTER_HELTH_PLUS,
} from "@static/staticConstents";
import { themeDefault } from "src/theme-revamp";
import DonutChart from "@pages/ShieldStarter/Components/DonutChart";
import { SCREEN_SIZE } from "@static/screen-size";
import MainContainer from "@pages/ShieldStarter/Components/Container";
import { Text } from "./../../Components/Text";
import { Checkbox } from "@pages/ShieldStarter/Components/Checkbox";
import VideoModal from "@pages/ShieldStarter/Components/Modals/VideoModal";
import Modal from "@components/_Revamp/Modal";
import { trackOnLoad } from "@pages/ShieldStarter/Helpers/dataAnalyticsHelpers";
import fetchSqsQuotation from "@pages/ShieldStarter/Helpers/fetchSqsQuotation";
import FloatingIcon from "@pages/ShieldStarter/Components/FloatingIcon";
import { clearNotifications } from "@redux/slices/SHIELD_STARTER/step1Slice";

const SectionContainer = styled.div<{ margin?: string }>`
  background-color: #ffffff;
  border-radius: 24px;
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  transition: all 0.2s ease;
  margin-bottom: 24px;
  padding: 36px 16px;

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 36px;
  }
`;

interface TagProps {
  color?: string;
  bg?: string;
  weight?: number;
}

const Tag = styled.div<TagProps>`
  border-radius: 8px;
  padding: 4px 8px 4px 8px;
  background: ${(props) => (props.bg ? props.bg : "#F2E6F1")};
  color: ${(props) => (props.color ? props.color : "#434343")};
  font-weight: ${(props) => (props.weight ? props.weight : 600)};
  font-size: 12px;
`;

interface NoteTextProps {
  fsize?: string;
}

const NoteText = styled.p<NoteTextProps>`
  font-weight: 400;
  font-size: ${(props) => (props.fsize ? props.fsize : "12px")};
  line-height: 140%;
  margin: 24px 0;
  color: #434343;
`;

interface HeaderTextProps {
  mt?: string;
  mb?: string;
}

const HeaderText = styled.h1<HeaderTextProps>`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #434343;
  margin-top: ${(props) => (props.mt ? props.mt : "64px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "24px")};
  padding-left: 22px;
  position: relative;

  &:before {
    background-color: #883e89;
    border-radius: 4px;
    content: "";
    width: 6px;
    height: 100%;
    position: absolute;
    left: 0;
  }
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
  }
`;

const Center = styled.div<HeaderTextProps>`
  margin-top: ${(props) => (props.mt ? props.mt : "20px")};
  display: flex;
  justify-content: center;
  width: 100%;
`;

interface PlanTextProps {
  mgt?: string;
}

const PlanText = styled.div<PlanTextProps>`
  margin-top: ${(props) => (props.mgt ? props.mgt : "4px")};
  display: flex;
  align-items: center;

  span {
    font-size: 12px;
    display: flex;
    font-weight: 600;
    color: #8a8988;
  }
`;

const List = styled.ul`
  margin-top: 10px;
  padding-left: 15px;

  li {
    margin-bottom: 10px;
    margin-left: 10px;
    padding-left: 15px;
    font-size: 14px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const ProductListContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 16px;
  gap: 16px;
  width: 100%;
  align-items: flex-start;
  position: relative;
  margin-top: 36px;

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    grid-gap: 0 24px;
    gap: 0 24px;
    width: auto;
    flex-direction: row;
  }
`;

const ProductList = styled.div`
  display: inline-flex;
  flex-direction: column;
  border: none;
  grid-gap: 13px;
  gap: 13px;
  background-color: #f5f5f5;
  border-radius: 32px;
  padding: 36px 24px 24px;
  justify-content: unset;
  transition: all 0.2s linear;
  align-self: stretch;
  flex-basis: 0;
  flex-grow: 1;
  position: relative;
  margin-top: 24px;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
  }
`;

const ProductIcon = styled.div`
  position: absolute;
  top: -22.5px;
  width: 45px;
  height: 45px;
  background: #f2e6f1;
  border-radius: 50%;
  display: flex;
  text-align: center;
  justify-content: center;

  img {
    width: 100%;
    padding: 8px;
  }
`;

function ChoosePlan() {
  const history = useHistory();
  const dispatch = useAvivaDispatch();
  const whomToBuy = useAvivaSelector(
    (state) => state.shieldStarterStep1.whomToBuy
  );
  const hasExistingPlan = useAvivaSelector(
    (state) => state.shieldStarterStep1.hasExistingPlan
  );
  const policyName = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  const promoCode = useAvivaSelector(
    (state) => state.shieldStarterStep2.promoCode
  );
  const campaignCode =
    useAvivaSelector((state) => state.loading?.campaignDetail?.campaignCode) ||
    null;

  const [activeBtn, setActiveBtn] = useState(false);
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [videoModalVisible, setVideoModalVisible] = useState<boolean>(false);

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  const onGetQuateClick = async () => {
    setActiveBtn(true);
    try {
      await fetchSqsQuotation(
        whomToBuy,
        policyName,
        dispatch,
        promoCode,
        undefined,
        campaignCode
      );
      history.push(ROUTE_PATH.SHIELD_STARTER_VIEW_QUOTATION);
    } catch (error) {
      history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
    }
  };

  const onChange = (event: any) => {
    const value = event.target.value;
    dispatch(updatePolicyName(value));
    dispatch(clearNotifications());
  };

  useEffect(() => {
    dispatch(updatePlanOverview(generatePlanOverView({}, dispatch)));
    const existingPlans = ["yes", "no"];
    if (!whomToBuy && !existingPlans.includes(hasExistingPlan)) {
      history.push(ROUTE_PATH.SHIELD_STARTER_GET_QUOTE);
    } else {
      trackOnLoad("sss_choose_plan_form");
    }
  }, []);

  const PLAN_PADDING = screenSize >= SCREEN_SIZE.mobilesUp ? "0 24px" : "0";
  const CHECKBOX_PADDING =
    screenSize >= SCREEN_SIZE.mobilesUp ? "36px" : "24px";
  return (
    <MainContainer
      step={2}
      backButtonPath={ROUTE_PATH.SHIELD_STARTER_GET_QUOTE}
    >
      <SectionContainer>
        <FloatingIcon />
        <Tag>Medical Insurance</Tag>
        <Text variant="title" margin="8px 0 25px">
          Singlife Shield Starter and Health Plus Starter
        </Text>
        <Link
          fontSize={14}
          fontSizeTablet={14}
          color="#883E89"
          text="Read our Product Summary"
          target="_blank"
          rel="noopener noreferrer"
          url={PRODUCT_SUMMARY_SHIELD_STARTER_HEALTH_PLUS}
          icon={IconDonwload}
          iconSize="xsm"
        />
        <Text fontSize="14px" variant="description" margin="24px 0 0">
          Affordable medical insurance plan and rider bundle that protects you
          against unexpected hospital bills.
        </Text>
        {/* <NoteText>
          *You’ll pay S$1 out of pocket (before GST) and the remaining annual
          premium of S$300 using MediSave.
        </NoteText> */}
        {/* <InfoContainer>
          <Icon name="info-black" className="icon-info" />
          <InfoText>
            Note: You must purchase Singlife Shield Starter in order to add
            Singlife Health Plus rider for enhanced coverage.
          </InfoText>
        </InfoContainer> */}
        <HeaderText>
          What you’ll love about Singlife Shield Starter and Health Plus Starter
        </HeaderText>
        <ProductListContainer>
          <ProductList>
            <ProductIcon>
              <img src={Product1}></img>
            </ProductIcon>
            <Text variant="description" fontSize="16px" fontWeight={600}>
              Lower out-of-pocket expenses at a budget-friendly premium
            </Text>
            <Text variant="base">
              Co-payment will be reduced to just 5% of the hospital bills, with
              just S$1^ add-on to your Shield plan.
            </Text>
          </ProductList>
          <ProductList>
            <ProductIcon>
              <img src={Product2}></img>
            </ProductIcon>
            <Text variant="description" fontSize="16px" fontWeight={600}>
              As-charged coverage of up to S$20,000 at preferred medical
              providers
            </Text>
            <Text variant="base">
              Your hospital bills at more than 600 of our
              <Link
                fontSize={14}
                fontSizeTablet={14}
                color="#883E89"
                target="_blank"
                rel="noopener noreferrer"
                url="https://singlife.com/en/medical-insurance/medicalspecialists?utm_source=sss&utm_medium=customerjourney&utm_campaign=usp"
                text=" preferred medical providers^"
              />{" "}
              are covered.
            </Text>
          </ProductList>
          <ProductList>
            <ProductIcon>
              <img src={Product3}></img>
            </ProductIcon>
            <Text variant="description" fontSize="16px" fontWeight={600}>
              Higher coverage of up to S$1 million from age 40
            </Text>
            <Text variant="base">
              Guaranteed conversion to{" "}
              <Link
                fontSize={14}
                fontSizeTablet={14}
                color="#883E89"
                target="_blank"
                rel="noopener noreferrer"
                url="https://singlife.com/en/medical-insurance/shield?utm_source=sss&utm_medium=customerjourney&utm_campaign=usp"
                text="Singlife Shield Plan 2"
              />{" "}
              at age 40 with no need for additional medical check-ups.
            </Text>
          </ProductList>
        </ProductListContainer>
        <NoteText>
          *Premiums quoted before GST. If you seek treatment at a non-preferred
          provider, meaning those not on the Singlife panel, you can claim only
          50% of your claimable hospital bill.
        </NoteText>
        <Center>
          <Link
            color="#883E89"
            underline={false}
            slotIcon="end"
            fontSize={16}
            text="Find out how Singlife Shield Starter and Health Plus Starter helped Andy"
            variant="button"
            icon={IconArrow}
            iconSize="xsm"
            fontWeight="600"
            theme={themeDefault}
            onClick={() => setVideoModalVisible(true)}
          />
        </Center>
      </SectionContainer>

      <SectionContainer>
        <HeaderText mt="0" mb="0">
          What you'll need to pay if you are hospitalised
        </HeaderText>
        <NoteText>
          Reduce your out-of-pocket expenses on your hospital bill with just
          S$1.00* add-on to your Shield plan.
        </NoteText>
        <Center style={{ marginBottom: "40px", marginTop: "36px" }}>
          <DonutChart />
        </Center>
        <NoteText style={{ textAlign: "center", width: "100%" }}>
          Note: Above figures are solely for illustration purposes, based on a
          S$10,000 bill at preferred medical provider.
        </NoteText>
        <RadioButtonGroup
          value={policyName}
          name="policy name"
          activeType="fill"
          widthIcon={false}
          iconALign="top"
          textAlign="left"
          padding={PLAN_PADDING}
          onChange={onChange}
          borderRadius="24px"
        >
          <RadioButton
            header={"Singlife Shield Starter \n\n"}
            value={SHIELD_STARTER}
          >
            <span
              style={{
                position: "absolute",
                right: CHECKBOX_PADDING,
              }}
            >
              <Checkbox
                type="radio"
                checked={policyName === SHIELD_STARTER}
                name="plan"
                newRedio
              />
            </span>
            <PlanText>
              <span>Plan Only</span>
              <span style={{ marginLeft: "auto" }}>
                <Tag color="#8A8988" bg="#fff">
                  S$300.00
                </Tag>
              </span>
            </PlanText>
            <List>
              <li>
                As-charged coverage of up to S$20,000/year at preferred medical
                providers
              </li>
              <li>
                Your out-of-pocket payment is capped at S$3,500 for the
                deductible plus 10% of the remaining hospital bill
              </li>
            </List>
          </RadioButton>
          <RadioButton
            header={"Singlife Shield Starter + \n Health Plus Starter"}
            value={SHIELD_STARTER_HELTH_PLUS}
          >
            <span
              style={{
                position: "absolute",
                right: CHECKBOX_PADDING,
              }}
            >
              <Checkbox
                type="radio"
                checked={policyName === SHIELD_STARTER_HELTH_PLUS}
                name="plan"
                newRedio
              />
            </span>
            <PlanText>
              <span>Plan + Rider</span>
              <span style={{ marginLeft: "auto" }}>
                <Tag color="#8A8988" bg="#fff" style={{ marginRight: "5px" }}>
                  S$300.00
                </Tag>
                <Tag color="#fff" bg="#883E89">
                  +S$1.00
                </Tag>
              </span>
            </PlanText>
            <List>
              <li>
                As-charged coverage of up to S$20,000/year at preferred medical
                providers
              </li>
              <li>
                Your co-payment is reduced to just{" "}
                <b style={{ color: "#00AC95" }}>5% of hospital bill</b>
              </li>
            </List>
          </RadioButton>
        </RadioButtonGroup>
        <NoteText>*Premiums quoted before GST</NoteText>
      </SectionContainer>

      <Center mt="64px">
        <Button
          label="Get my quote"
          variant="default"
          width="180px"
          height="52px"
          padding="15px 0"
          disabled={activeBtn}
          onClick={onGetQuateClick}
        />
      </Center>
      {videoModalVisible && (
        <Modal
          show={videoModalVisible}
          onClose={() => setVideoModalVisible(false)}
        >
          <VideoModal />
        </Modal>
      )}
    </MainContainer>
  );
}

export default ChoosePlan;
